import type { JSX, ReactNode } from 'react';
import type { BrandConfig, LegalConfig, Storefront } from '@kitup/brand';
import { BrandContext } from './context.js';
import { LegalContext } from './legal-context.js';
import { StorefrontContext } from './storefront-context.js';

/**
 * Brand, legal bundle and storefront travel together — all come from the same
 * `@kitup/brand-*` package — but sit in separate contexts rather than one so
 * that `BrandConfig` itself stays free of JSX: the API imports the brand, and
 * anything reachable from it is loaded by the API process.
 */
export function BrandProvider({
  brand,
  legal,
  storefront,
  children,
}: {
  readonly brand: BrandConfig;
  readonly legal: LegalConfig;
  readonly storefront: Storefront;
  readonly children: ReactNode;
}): JSX.Element {
  return (
    <BrandContext.Provider value={brand}>
      <LegalContext.Provider value={legal}>
        <StorefrontContext.Provider value={storefront}>{children}</StorefrontContext.Provider>
      </LegalContext.Provider>
    </BrandContext.Provider>
  );
}
